/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFooterFragment} from '@amblique/contentful/app/contentful/fragments/footer/base-footer.fragment';
import {BaseFooterColumnFragment} from '@amblique/contentful/app/contentful/fragments/footer-column/base-footer-column.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const FooterFragment = gql`
  ${BaseFooterColumnFragment}
  ${BaseFooterFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}

  fragment FooterFragment on Footer {
    ...BaseFooterFragment

    columnsCollection {
      items {
        __typename
        ... on FooterColumn {
          ...BaseFooterColumnFragment
        }
      }
    }
    columnsCursorCollection {
      items {
        __typename
        ... on FooterColumn {
          ...BaseFooterColumnFragment
        }
      }
    }
    countriesCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    countriesCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    logo {
      ...BaseImageFragment
    }
    paymentsCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
    paymentsCursorCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
    showroomFooter {
      ...BaseImageFragment
    }
    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    socialLinksCursorCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
